import { render } from "./Trainings.vue?vue&type=template&id=4923a14e&scoped=true"
import script from "./Trainings.vue?vue&type=script&lang=js"
export * from "./Trainings.vue?vue&type=script&lang=js"

import "./Trainings.vue?vue&type=style&index=0&id=4923a14e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4923a14e"]])

export default __exports__